import { OrderState } from '../enums/order-state.enum';
import { Company } from './company.model';
import { ModelHelper } from '../classes/model-helper';
import { Patient } from './patient.model';
import { Restoration } from './restoration.model';

export class Order {
	uid: string;
	orderComment: string;
	orderNumber: number;
	orderDate: Date;
	returnDate: Date;
	purchaser: Company;
	contractor: Company;
	state: OrderState;
	patient: Patient;
	restorations: Restoration[];
	externalUid: string;
	insurance: string;

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param item
	 */
	static map(data: any, item: Order = new Order()): Order {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 */
	public map(data: any): Order {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'orderComment');
		ModelHelper.map(data, this, 'orderNumber');
		ModelHelper.map(data, this, 'orderDate', Date);
		ModelHelper.map(data, this, 'returnDate', Date);
		ModelHelper.map(data, this, 'purchaser', Company);
		ModelHelper.map(data, this, 'contractor', Company);
		ModelHelper.map(data, this, 'state');
		ModelHelper.map(data, this, 'patient', Patient);
		ModelHelper.map(data, this, 'restorations', Restoration);
		ModelHelper.map(data, this, 'externalUid');
		ModelHelper.map(data, this, 'insurance');

		return this;
	}

	get orderPurchaserAndNumber() {
		return {
			orderNumber: this.orderNumber,
			orderPurchaser: this.purchaser.name
		};
	}

	get orderContractorAndNumber() {
		return {
			orderNumber: this.orderNumber,
			orderContractor: this.contractor.name
		};
	}
}
